import { Checkboxes, Details } from 'nhsuk-react-components';
import { FC, useEffect } from 'react';
import { SECTIONS } from './Constants';

// eslint-disable-next-line import/prefer-default-export
export const RoutingPlanIdsSection: FC<{
    routingIds: string;
    checkedItems: Record<string, boolean>;
    sectionChecked: boolean;
    onSectionChange: (id: string) => void;
    handleCheckboxChange: (sectionKey: string, id: string) => void;
// eslint-disable-next-line react/function-component-definition
}> = ({
  routingIds,
  checkedItems,
  sectionChecked,
  onSectionChange,
  handleCheckboxChange,
}) => {
  const plansArray = routingIds ? routingIds.split('|').filter(Boolean) : [];
  const disabled = plansArray.length === 0;
  const id = SECTIONS.ROUTING_PLAN_IDS;

  const selectedItems = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    plansArray.map((plan) => {
      // eslint-disable-next-line no-param-reassign
      checkedItems[plan] = false;
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Checkboxes.Item
      id={id}
      aria-label={id}
      disabled={disabled}
      data-testid={id}
      checked={sectionChecked}
      onChange={() => onSectionChange(id)}
    >
      <Details>
        <Details.Summary className="nhsuk-u-font-weight-bold">
          Message plans (
          {selectedItems}
          /
          {plansArray.length}
          {' '}
          selected)
        </Details.Summary>
        {plansArray.length > 0 && (
        <Details.Text className="nhsuk-u-margin-top-5">
          <Checkboxes>
            {plansArray.map((plan, index) => (
              <Checkboxes.Item
                // eslint-disable-next-line react/no-array-index-key
                key={`${plan}-${index}`}
                id={plan}
                aria-label={plan}
                data-testid={plan}
                checked={checkedItems[plan] || false}
                onChange={() => handleCheckboxChange(
                  SECTIONS.ROUTING_PLAN_IDS,
                  plan,
                )}
              >
                {plan}
              </Checkboxes.Item>
            ))}
          </Checkboxes>
        </Details.Text>
        )}
      </Details>
    </Checkboxes.Item>
  );
};
